import { Grid, Stack, Typography } from "@mui/material";
import ArtistCard from "../../components/Card/Artist";
import { Loader } from "../../components/Loader";
import { ArtistFragment } from "../../generated/firebase";

const ArtistTab = ({
  artists,
  loadingArtists,
  searchQs,
  isMobileScreen,
}: {
  artists: ArtistFragment[];
  loadingArtists: boolean;
  searchQs: string;
  isMobileScreen: boolean;
}) => {
  return (
    <>
      {loadingArtists ? (
        <Loader />
      ) : artists.length > 0 ? (
        <Stack gap={3} width="100%">
          <Grid container spacing={1}>
            {artists.map((artist) => (
              <Grid item xs={12 / 2} md={12 / 4} key={artist.id}>
                <ArtistCard artist={artist} size="small" imageHeight={isMobileScreen ? "200px" : "300px"} />
              </Grid>
            ))}
          </Grid>
        </Stack>
      ) : (
        <Typography variant="h3" align="center">
          No artists found for "{searchQs}"
        </Typography>
      )}
    </>
  );
};

export default ArtistTab;
